import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData, SyncData, SyncReprint, deleteData, TableNameChanges, } from '../../../apiService';
import {
    Card,
    CardContent,
    IconButton,
    Typography,
    Paper,
    TableHead
} from '@mui/material';
import './EditKotActions.css';
import './InvoiceModal.css';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import RestaurantMenu from '@mui/icons-material/Restaurant';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SendIcon from '@mui/icons-material/Send';
import Badge from '@mui/material/Badge';
import ReceiptIcon from '@mui/icons-material/Receipt';
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import CancelIcon from '@mui/icons-material/Cancel';
import PhoneIcon from '@mui/icons-material/Phone';
import { generateKOTPDF } from '../KOT/Estimate';
import BillPrint from '../Sale/Bill'; // Import the LabelPrint component
import Payment from '@mui/icons-material/Payment';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import DoneIcon from '@mui/icons-material/Done';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DescriptionModal from './DescriptionModal'; // Import the DescriptionModal component
import CircularProgress from '@mui/material/CircularProgress';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import Modal from '@mui/material/Modal';
import { generateBillPDF } from "../Sale/BillPrintPDF";
import DeleteIcon from '@mui/icons-material/Delete';
import Select from 'react-select';
import BillSaveLoader from '../../BillSaveLoader';

const EditKOT = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, permissions, token, logout, roleName } = useAuth();
    const [discountOptions, setDiscountOptions] = useState([]);
    const [selecteDiscount, setSelectedDiscount] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isBillSaving, setIsBillSaving] = useState(false);
    const [isKotSaving, setIsKotSaving] = useState(false);
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');


    const [expandedCategories, setExpandedCategories] = useState([]);
    const handleExpandClick = (categoryName) => {
        setExpandedCategories((prevExpanded) => {
            if (prevExpanded.includes(categoryName)) {
                return prevExpanded.filter((cat) => cat !== categoryName);
            } else {
                return [...prevExpanded, categoryName];
            }
        });
    };

    const [isModalDiscOpen, setIsModalDiscOpen] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [description, setDescription] = useState('');

    const saveDescription = (newDescription) => {
        setSelectedItems((prevItems) =>
            prevItems.map((item) =>
                item.ItemId === selectedItemId
                    ? { ...item, description: newDescription }
                    : item
            )
        );

        setIsModalDiscOpen(false);
    };

    const [totalQuantity, setTotalQuantity] = useState(0);
    const [kotDate, setKOTDate] = useState('');
    const [kotTime, setKOTTime] = useState('');
    const [tableName, setTableName] = useState('');
    const [tableId, setTableId] = useState('');
    const [showContact, setShowContact] = useState(false);
    const [contactDetails, setContactDetails] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [correctPassword, setcorrectPassword] = useState('');

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];
    const formattedTime = currentDate.toTimeString().split(' ')[0];

    const [categoryData, setCategoryData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderedItems, setOrderedItems] = useState([]);

    useEffect(() => {
        fetchData('KOTApi', `/ItemTableDetails/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setCategoryData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Data:', error);
            });

        fetchData('KOTApi', `/OrderItemDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setOrderedItems(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Data:', error);
            });

        fetchData('KOTApi', `/TableNameDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setTableId(response.response_data.Id);
                    setTableName(response.response_data.Name);
                    setKOTDate(formattedDate);
                    setKOTTime(formattedTime);
                    if (response.response_data.Description) {
                        setContactDetails(response.response_data.Description);
                        setShowContact(true);
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching Table Name Details:', error);
            });
        fetchData('CompanyApi', `/CompanyDetails/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setcorrectPassword(response.response_data.ReprintPassword);
                }
            })
            .catch((error) => {
                console.error('Error fetching Table Name Details:', error);
            });

        fetchData('KOTApi', `/GetDiscountOptions/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setDiscountOptions(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Discount Options:', error);
            });
    }, [id, formattedDate, formattedTime]);

    const handleIncrement = (CategoryId, ItemId, itemName) => {
        setSelectedItems((prevItems) => {
            const existingItem = prevItems.find((item) => item.ItemId === ItemId);
            if (existingItem) {
                // If the item is already in the list, update its quantity
                setTotalQuantity((prevTotal) => prevTotal + 1);
                return prevItems.map((item) =>
                    item.ItemId === ItemId ? { ...item, Quantity: item.Quantity + 1 } : item
                );
            } else {
                // If the item is not in the list, add it with quantity 1
                setTotalQuantity((prevTotal) => prevTotal + 1);
                return [...prevItems, { CategoryId, ItemId, Quantity: 1, itemName }];
            }
        });
    };

    const handleDecrement = (ItemId) => {
        setSelectedItems((prevItems) => {
            const existingItem = prevItems.find((item) => item.ItemId === ItemId);
            if (existingItem) {
                setTotalQuantity((prevTotal) => Math.max(prevTotal - 1, 0)); // Decrement total quantity
                // If the item is already in the list, update its quantity
                return prevItems.map((item) =>
                    item.ItemId === ItemId ? { ...item, Quantity: Math.max(item.Quantity - 1, 0) } : item
                );
            } else {
                // If the item is not in the list, do nothing
                return prevItems;
            }
        });
    };

    const getTotalQuantityForCategory = (categoryId) => {
        return selectedItems
            .filter((item) => item.CategoryId === categoryId)
            .reduce((total, item) => total + item.Quantity, 0);
    };

    const getOrderTotalQuantity = (Id) => {
        return orderedItems
            .filter((item) => item.Id === Id)
            .reduce((total, item) => total + item.TotalQty, 0);
    };

    const getTotalQuantity = () => {
        return orderedItems
            .reduce((total, item) => total + item.TotalQty, 0);
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const kotdata = {
            Id: id,
            TableId: tableId,
            ModifiedBy: userId,
            CompanyId: companyId,
            ModifiedDate: new Date(),
            Description: contactDetails,
        };

        const CreateData = {
            KOT: kotdata,
            KOTDetails: selectedItems
        };

        updateData('KOTApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                if (response.response === '1111' && companyId != 4) {
                    const kotid = response.kotId;
                    handleKOTPrint(kotid);
                }
                setIsLoading(false);
                history.push('/Home');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    const handleKOTPrint = async (kotid) => {
        try {
            const response = await fetchData('KOTApi', `/KOTPrint/${kotid}`, token);
            const labelData = response.response_data;
            await generateKOTPDF(labelData);

            try {
                SyncData('KOTApi', `${kotid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };

    // FOR FINAL BILL

    const [modalData, setModalData] = useState({
        CompanyId: '',
        InvoiceDate: '',
        InvoiceTime: '',
        InvoiceNumber: '',
        TableId: '',
        KOTId: '',
        FinYear: '',
        Amount: '',
        DiscountAmount: '',
        DiscountPer: '',
        NetAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        RoundOff: '',
        PaymentType: 3,
        CreatedBy: '',
        CreatedDate: ''
    });

    const [itemdata, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);



    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const openDetailModal = async (item) => {

        try {
            const response = await fetchData('SaleApi', `/InvoiceCreateDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setModalData(response.response_data.Sale);
                setData(response.response_data.SaleDetails);

                setModalData((prevData) => ({
                    ...prevData,
                    InvoiceDate: formattedDate,
                    InvoiceTime: formattedTime,
                    PaymentType: "3",
                    CreatedBy: userId,
                }));

                setKOTDate(formattedDate);
                setKOTTime(formattedTime);

                setIsModalOpen(true);

            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState("3");


    const handleChange = (event) => {
        const { name, value, type } = event.target;

        if (name === 'DiscountPer') {
            const discountPercentage = parseFloat(value) || 0;
            setSelectedDiscount(discountPercentage);
            setModalData((prevData) => ({
                ...prevData,
                DiscountPer: discountPercentage.toFixed(2),
                ModifiedBy: userId,
            }));


            // Calculate discount and other values for each item in itemdata
            const updatedItemData = itemdata.map((item) => {
                const amount = parseFloat(item.Amount) || 0;
                const discountAmount = (amount * discountPercentage) / 100;
                const netAmount = (amount - discountAmount).toFixed(2);
                const cgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const sgstAmount = ((netAmount * (item.GSTRate / 2)) / 100).toFixed(2);
                const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                return {
                    ...item,
                    DiscountPer: discountPercentage.toFixed(2),
                    DiscountAmount: discountAmount.toFixed(2),
                    NetAmount: netAmount,
                    CGSTAmount: cgstAmount,
                    SGSTAmount: sgstAmount,
                    TotalAmount: totalAmount,
                };
            });

            setData(updatedItemData);


            // Update the totals based on the updatedItemData
            const invAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const netAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
            const cgstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const sgstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const igstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
            const discAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);

        }
        else {
            setSelectedPaymentType(event.target.value);
            setModalData((prevData) => ({
                ...prevData,
                PaymentType: event.target.value,
            }));

        }
    };

    const totalCalculation = (invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount) => {
        const packingCharge = parseFloat(modalData.PackingCharge) || 0;
        let amount = parseFloat(invAmount);
        let netamount = parseFloat(netAmount);
        let netAmt = netAmount + parseFloat(cgstAmount) + parseFloat(sgstAmount) + parseFloat(igstAmount) + packingCharge;
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmount = (netAmt + roundOffValue).toFixed(2);

        setModalData((prevData) => ({
            ...prevData,
            Amount: amount.toFixed(2),
            NetAmount: netamount.toFixed(2),
            TotalAmount: totalAmount,
            DiscountAmount: discAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            CGSTAmount: cgstAmount.toFixed(2),
            SGSTAmount: sgstAmount.toFixed(2),
            IGSTAmount: igstAmount.toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const updateRecord = async (event) => {
        event.preventDefault();
        setIsSaveConfirmOpen(true);
    };

    const handleSaveConfirm = async () => {
        setIsSaveConfirmOpen(false);
        setIsLoading(true);
        setIsBillSaving(true);

        const CreateData = {
            Sale: modalData,
            SaleDetails: itemdata
        };

        try {
            const response = await postData('SaleApi', CreateData, token);
            if (response.response === '1111') {
                const SaleId = response.kotId;
                await handleSalePrint(SaleId);
            }

            // Keep loading visible for a moment to show completion
            setTimeout(() => {
                setIsLoading(false);
                setIsBillSaving(false);
                history.push('/Home');
            }, 1500);

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
        } catch (error) {
            console.error('KOT Create error:', error);
            setIsLoading(false);
            setIsBillSaving(false);
        }
    };

    const CancelRecord = async (event) => {
        event.preventDefault();
        setIsCancelConfirmOpen(true);
    };

    const handleCancelConfirm = async () => {
        setIsCancelConfirmOpen(false);
        setIsLoading(true);

        try {
            const response = await deleteData('KOTApi', `${id}`, token);
            if (response) {
                history.push('/Home');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            }
        } catch (error) {
            console.error('Error deleting record:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSalePrint = async (saleid) => {
        try {
            const response = await fetchData('SaleApi', `/SalePrint/${saleid}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            // If multiple labels — loop through each one and generate PDF
            for (const data of labelsToPrint) {
                await generateBillPDF(data);
            }

        } catch (error) {
            console.error('Error generating Invoice PDF:', error);
        }
    };


    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);
    const [isCancelConfirmOpen, setIsCancelConfirmOpen] = useState(false);
    const [isSaveConfirmOpen, setIsSaveConfirmOpen] = useState(false);

    // Function to handle password input change
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    // Function to handle password check
    const handlePasswordCheck = () => {
        // Perform your password check logic here
        // For simplicity, let's assume the correct password is 'secret'

        if (password === correctPassword) {
            // Password is correct, proceed to reprint KOT
            setIsPasswordDialogOpen(false);
            reprintKOT(id);
            setPassword('');
        } else {
            // Password is incorrect, show error message
            setPasswordError('Incorrect password. Please try again.');
        }
    };


    const reprintKOT = async (id) => {
        try {
            const response = await fetchData('KOTApi', `/KOTREPrint/${id}`, token);
            const labelData = response.response_data;
            await generateKOTPDF(labelData);

            try {
                SyncReprint('KOTApi', `${id}`, `${userId}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };

    const [isModalEditOpen, setIsModalEditOpen] = useState(false);

    const openEditModal = () => {
        {
            setIsModalEditOpen(true);
        }
    }

    const closeEditModal = () => {
        {
            setIsModalEditOpen(false);
        }
    }

    const [selectedTable, setSelectedTable] = useState("");
    const [dropdownTableOptions, setDropdownTableOptions] = useState([]);
    useEffect(() => {
        fetchDropdownTableOptions();
    }, []);

    const fetchDropdownTableOptions = () => {
        // const response = await fetchData('KOTApi', `/KOTREPrint/${id}`, token);
        fetchData('KOTApi', `/tableName/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownTableOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Table dropdown options:', error);
            });
    };


    const handleUpdate = async () => {
        // Check if a valid table is selected
        if (!selectedTable) {
            alert("Please select a table.");
            return;
        }

        try {
            //   SyncReprint('KOTApi', `${id}`, `${userId}`, token)
            const response = await TableNameChanges('KOTApi', `${id}`, `${selectedTable}`, token);
            if (response) {
                history.push('/Home');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            }
        } catch (error) {
            console.error('Error deleting record:', error);
        }

    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = itemdata.map((item, i) =>
                i === index ? { ...item, IsActive: false } : item
            );

            setData(updatedRecords); // Update state with IsActive=false instead of removing

            // Filter only active records for calculation
            const activeItems = updatedRecords.filter(item => item.IsActive == true);

            const invAmount = activeItems.reduce((sum, item) => sum + (parseFloat(item.Amount) || 0), 0);
            const netAmount = activeItems.reduce((sum, item) => sum + (parseFloat(item.NetAmount) || 0), 0);
            const cgstAmount = activeItems.reduce((sum, item) => sum + (parseFloat(item.CGSTAmount) || 0), 0);
            const sgstAmount = activeItems.reduce((sum, item) => sum + (parseFloat(item.SGSTAmount) || 0), 0);
            const igstAmount = activeItems.reduce((sum, item) => sum + (parseFloat(item.IGSTAmount) || 0), 0);
            const discAmount = activeItems.reduce((sum, item) => sum + (parseFloat(item.DiscountAmount) || 0), 0);

            totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);
        }
    };

    const handleCalculation = (e, index) => {
        const { name, value } = e.target;
        const discountPercentage = 0;
        const GstNotApplicable = modalData.GstNotApplicable ? modalData.GstNotApplicable : false;;

        const updatedItemData = itemdata.map((item, i) => {
            if (i === index) {
                if (name === 'Quantity') {
                    const quantity = parseFloat(value) || 0;
                    const rate = parseFloat(item.Rate) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = item.GSTRate;
                    if (GstNotApplicable) {
                        gstrate = 0;
                    }

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Quantity: quantity,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate,
                    };
                } else if (name === 'Rate') {
                    const rate = parseFloat(value) || 0;
                    const quantity = parseFloat(item.Quantity) || 0;
                    const amount = (quantity * rate).toFixed(2);
                    const discountAmount = (amount * discountPercentage) / 100;
                    const netAmount = (amount - discountAmount).toFixed(2);
                    let gstrate = item.GSTRate;
                    if (GstNotApplicable) {
                        gstrate = 0;
                    }

                    const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
                    const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

                    return {
                        ...item,
                        Rate: rate,
                        Amount: amount,
                        DiscountPer: discountPercentage.toFixed(2),
                        DiscountAmount: discountAmount.toFixed(2),
                        NetAmount: netAmount,
                        CGSTAmount: cgstAmount,
                        SGSTAmount: sgstAmount,
                        TotalAmount: totalAmount,
                        GSTRate: gstrate,
                    };
                }
                // --- Handle Description ---
                else if (name === 'description') {
                    return {
                        ...item,
                        description: value, // just update text, no recalculation
                    };
                }
            }
            return item;
        });

        setData(updatedItemData);

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const cgstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
        const sgstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
        const igstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
        const discAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

        totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);
    };

    const [newRecordData, setNewRecordData] = useState([]);
    const [isModalOpenNewItem, setIsModalOpenNewItem] = useState(false);
    const toggleModalNewItem = () => {
        setIsModalOpenNewItem(!isModalOpenNewItem);
    };

    // For Item
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemOptions, setItemOptions] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);

    useEffect(() => {

        const fetchItemData = async () => {
            try {
                const response = await fetchData('SaleApi', `/Item/${companyId}`, token);
                const responseData = response.response_data;

                const options = responseData.map((item) => ({
                    label: item.Name,
                    value: item.Id,
                }));

                setItemOptions(options);
                setItemDetails(responseData);
            } catch (error) {
                console.error('Error fetching item data:', error);
            }
        };

        fetchItemData();
    }, [companyId, token]);



    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setNewRecordData({
            ...newRecordData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';


        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {
            // Update the rate in the modal data
            setNewRecordData({
                ...newRecordData,
                Rate: selectedItemDetail.Rate, // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate,
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                IsActive: true,
            });
        } else {
            // Handle the case where the item detail is not found
            setNewRecordData({
                ...newRecordData,
                Rate: '0',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                IsActive: true,
            });
        }
    };

    const addRecord = () => {

        if (!newRecordData.ItemName && !newRecordData.Quantity) {
            return;
        }
        const updatedItemData = [...itemdata, newRecordData];
        setData(updatedItemData);
        setNewRecordData([]);
        setSelectedItem(null);
        toggleModalNewItem();

        // Update the totals based on the updatedItemData
        const invAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const netAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.NetAmount), 0);
        const cgstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
        const sgstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
        const igstAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.IGSTAmount) || 0, 0);
        const discAmount = updatedItemData.filter(item => item.IsActive == true).reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);

        totalCalculation(invAmount, netAmount, cgstAmount, sgstAmount, igstAmount, discAmount);
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const discountPercentage = 0;
        // Update the new record data
        setNewRecordData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        const GstNotApplicable = modalData.GstNotApplicable ? modalData.GstNotApplicable : false;
        // If the input is for quantity, calculate the amount
        if (name === 'Quantity') {
            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(newRecordData.Rate) || 0;
            const amount = (quantity * rate).toFixed(2);

            const discountAmount = (amount * discountPercentage) / 100;
            const netAmount = (amount - discountAmount).toFixed(2);
            let gstrate = newRecordData.GSTRate;
            if (GstNotApplicable) {
                gstrate = 0;
            }

            const cgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
            const sgstAmount = ((netAmount * (gstrate / 2)) / 100).toFixed(2);
            const totalAmount = (parseFloat(netAmount) + parseFloat(cgstAmount) + parseFloat(sgstAmount)).toFixed(2);

            // Update the new record data with the calculated amount
            setNewRecordData((prevData) => ({
                ...prevData,
                Amount: amount,
                DiscountPer: discountPercentage,
                DiscountAmount: discountAmount.toFixed(2),
                NetAmount: netAmount,
                CGSTAmount: cgstAmount,
                SGSTAmount: sgstAmount,
                TotalAmount: totalAmount,
                GSTRate: gstrate,
            }));
        }
    };

    const [modalDataEditKot, setModalDataEditKot] = useState({
        CompanyId: '',
    });

    const [itemdataEditKot, setDataEditKot] = useState([]);
    const [isModalOpenEditKot, setIsModalOpenEditKot] = useState(false);



    const toggleModalEditKot = () => {
        setIsModalOpenEditKot(!isModalOpenEditKot);
    };

    const openDetailModalEditKot = async (item) => {

        try {
            const response = await fetchData('KOTApi', `/KotDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setModalDataEditKot(response.response_data.KOT);
                setDataEditKot(response.response_data.KOTDetails);

                setModalDataEditKot((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));

                setIsModalOpenEditKot(true);

            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const handleCalculationEdit = (e, index) => {
        const { name, value } = e.target;

        const updatedItemData = itemdataEditKot.map((item, i) => {
            if (i === index) {
                if (name === 'Quantity') {
                    return {
                        ...item,
                        Quantity: value, // just update text, no recalculation
                    };
                }
                // --- Handle Description ---
                else if (name === 'description') {
                    return {
                        ...item,
                        description: value, // just update text, no recalculation
                    };
                }
            }
            return item;
        });

        setDataEditKot(updatedItemData);

    };

    const updateRecordEditKot = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setIsKotSaving(true);
        const isConfirmed = window.confirm("Are you sure you want to save the record?");

        if (isConfirmed) {
            const CreateData = {
                KOT: modalDataEditKot,
                KOTDetails: itemdataEditKot
            };

            try {
                const response = await postData('KOTEditApi', CreateData, token);
                if (response.response === '1111') {
                    // Keep loading visible for a moment to show completion
                    setTimeout(() => {
                        setIsLoading(false);
                        setIsKotSaving(false);
                        window.location.reload();
                    }, 1500);
                }
            } catch (error) {
                console.error('KOT Create error:', error);
                setIsLoading(false);
                setIsKotSaving(false);
            }
        } else {
            setIsLoading(false);
            setIsKotSaving(false);
        }
    };


    return (
        <div style={{
            minHeight: '100vh',
            background: '#f5f5f0',
            padding: '12px',
            paddingBottom: totalQuantity > 0 ? '80px' : '12px'
        }}>
            <style>
                {`
          .menu-container {
            max-width: 1200px;
            margin: 0 auto;
          }

          .menu-header {
            background: linear-gradient(135deg, #f6f8f2 0%, #edf1e6 100%);
            border: 1px solid rgba(106, 130, 59, 0.15);
            border-left: 4px solid #6a823b;
            border-radius: 12px;
            padding: 10px 16px;
            margin-bottom: 16px;
            box-shadow: 0 4px 12px rgba(106, 130, 59, 0.08);
            color: #2e3a1f;
          }

          .menu-title {
            font-size: 16px;
            font-weight: 700;
            color: #2e3a1f;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 8px;
            white-space: nowrap;
          }

          .menu-title svg {
            font-size: 18px;
            color: #6a823b;
          }

          .menu-subtitle {
            color: #5d6b4f;
            font-size: 11px;
            margin-top: 0;
            white-space: nowrap;
          }

          .category-card {
            background: #ffffff;
            border: 1px solid #e0e0e0;
            border-radius: 10px;
            margin-bottom: 10px;
            overflow: hidden;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
            transition: all 0.3s ease;
          }

          .category-card:hover {
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
          }

          .category-header {
            padding: 10px 14px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fafafa;
            transition: all 0.3s ease;
            border-bottom: 1px solid #e0e0e0;
          }

          .category-header:hover {
            background: #f0f0f0;
          }

          .category-name {
            font-size: 15px;
            font-weight: 700;
            color: #2c3e50;
            display: flex;
            align-items: center;
            gap: 7px;
          }

          .category-header svg {
            font-size: 18px;
          }

          .category-badge {
            background: linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%);
            color: white;
            padding: 2px 8px;
            border-radius: 8px;
            font-size: 10px;
            font-weight: 700;
            box-shadow: 0 1px 4px rgba(252, 74, 26, 0.3);
          }

          .menu-item-row {
            padding: 8px 14px;
            border-bottom: 1px solid #f0f0f0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            transition: all 0.3s ease;
          }

          .menu-item-row:last-child {
            border-bottom: none;
          }

          .menu-item-row:hover {
            background: #fafafa;
          }

          .menu-item-name {
            font-size: 13px;
            font-weight: 600;
            color: #34495e;
            flex: 1;
          }

          .quantity-controls {
            display: flex;
            align-items: center;
            gap: 7px;
            background: #f8f9fa;
            padding: 3px 8px;
            border-radius: 8px;
            border: 1px solid #e0e0e0;
          }

          .quantity-btn {
            background: linear-gradient(135deg, #56ab2f 0%, #a8e063 100%);
            color: white;
            border: none;
            width: 24px;
            height: 24px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 1px 4px rgba(86, 171, 47, 0.3);
          }

          .quantity-btn:hover {
            transform: scale(1.1);
            box-shadow: 0 3px 10px rgba(86, 171, 47, 0.5);
          }

          .quantity-btn.remove {
            background: linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%);
            box-shadow: 0 2px 6px rgba(252, 74, 26, 0.3);
          }

          .quantity-btn.remove:hover {
            box-shadow: 0 2px 8px rgba(252, 74, 26, 0.4);
          }

          .quantity-display {
            font-size: 14px;
            font-weight: 700;
            color: #2c3e50;
            min-width: 22px;
            text-align: center;
          }

          .info-btn {
            background: #e3f2fd;
            border: 1px solid #90caf9;
            color: #1976d2;
            width: 26px;
            height: 26px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
            margin-left: 5px;
          }

          .info-btn:hover {
            background: #bbdefb;
            transform: scale(1.05);
          }

          .cart-footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: #ffffff;
            border-top: 1px solid #e0e0e0;
            padding: 10px 14px;
            box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
            z-index: 1000;
          }

          .cart-content {
            max-width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
          }

          .cart-info {
            display: flex;
            align-items: center;
            gap: 10px;
            flex: 1;
          }

          .cart-icon-wrapper {
            background: linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%);
            width: 36px;
            height: 36px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 8px rgba(252, 74, 26, 0.3);
          }

          .cart-details {
            color: #2c3e50;
          }

          .cart-items-count {
            font-size: 18px;
            font-weight: 800;
            color: #2c3e50;
          }

          .cart-label {
            font-size: 10px;
            color: #7f8c8d;
            font-weight: 600;
          }

          .send-btn {
            background: linear-gradient(135deg, #56ab2f 0%, #a8e063 100%);
            color: white;
            border: none;
            padding: 8px 20px;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            box-shadow: 0 2px 8px rgba(86, 171, 47, 0.3);
            transition: all 0.3s ease;
            text-transform: none;
          }

          .send-btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(86, 171, 47, 0.4);
          }

          .send-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .expand-icon {
            transition: transform 0.3s ease;
            color: #7f8c8d;
            font-size: 20px;
          }

          .expand-icon.expanded {
            transform: rotate(180deg);
          }

          .cart-icon-wrapper svg {
            font-size: 20px;
          }

          .send-btn svg {
            font-size: 16px;
          }

          /* Tablet - 768px and below */
          @media (max-width: 768px) {
            .menu-container {
              padding: 0 8px;
            }

            .menu-header {
              padding: 12px 16px;
              margin-bottom: 12px;
            }

            .menu-title {
              font-size: 17px;
            }

            .menu-title svg {
              font-size: 18px;
            }

            .menu-subtitle {
              font-size: 11px;
            }

            .category-card {
              margin-bottom: 10px;
            }

            .category-header {
              padding: 10px 14px;
            }

            .category-name {
              font-size: 14px;
              gap: 6px;
            }

            .category-header svg {
              font-size: 16px;
            }

            .menu-item-row {
              padding: 8px 12px;
            }

            .menu-item-name {
              font-size: 13px;
            }

            .quantity-controls {
              gap: 6px;
              padding: 3px 7px;
            }

            .quantity-btn {
              width: 24px;
              height: 24px;
            }

            .quantity-display {
              font-size: 13px;
              min-width: 20px;
            }

            .info-btn {
              width: 26px;
              height: 26px;
              margin-left: 4px;
            }

            .cart-footer {
              padding: 10px 12px;
            }

            .cart-icon-wrapper {
              width: 36px;
              height: 36px;
            }

            .cart-items-count {
              font-size: 17px;
            }

            .cart-label {
              font-size: 10px;
            }

            .send-btn {
              padding: 8px 18px;
              font-size: 12px;
              gap: 5px;
            }
          }

          /* Phone - 480px and below */
          @media (max-width: 480px) {
            .menu-container {
              padding: 0;
            }

            .menu-header {
              padding: 10px 12px;
              margin-bottom: 10px;
              border-radius: 8px;
            }

            .menu-title {
              font-size: 15px;
              gap: 6px;
            }

            .menu-title svg {
              font-size: 16px;
            }

            .menu-subtitle {
              font-size: 10px;
              margin-top: 2px;
            }

            .category-card {
              margin-bottom: 8px;
              border-radius: 8px;
            }

            .category-header {
              padding: 8px 12px;
            }

            .category-name {
              font-size: 13px;
              gap: 5px;
            }

            .category-header svg {
              font-size: 15px;
            }

            .category-badge {
              font-size: 9px;
              padding: 2px 6px;
            }

            .menu-item-row {
              padding: 10px 12px;
              flex-direction: row;
              flex-wrap: wrap;
              gap: 8px;
            }

            .menu-item-name {
              font-size: 12px;
              width: 100%;
              margin-bottom: 4px;
            }

            .quantity-controls {
              flex: 1;
              min-width: 120px;
              justify-content: space-between;
              gap: 8px;
              padding: 4px 8px;
            }

            .quantity-btn {
              width: 26px;
              height: 26px;
            }

            .quantity-display {
              font-size: 13px;
              min-width: 24px;
            }

            .info-btn {
              width: 26px;
              height: 26px;
              margin-left: 0;
            }

            .expand-icon {
              font-size: 18px;
            }

            .cart-footer {
              padding: 8px 10px;
            }

            .cart-content {
              gap: 8px;
            }

            .cart-info {
              gap: 8px;
            }

            .cart-icon-wrapper {
              width: 32px;
              height: 32px;
            }

            .cart-icon-wrapper svg {
              font-size: 18px;
            }

            .cart-items-count {
              font-size: 16px;
            }

            .cart-label {
              font-size: 9px;
            }

            .send-btn {
              padding: 8px 16px;
              font-size: 12px;
              gap: 4px;
              white-space: nowrap;
            }

            .send-btn svg {
              font-size: 14px;
            }
          }

          /* Extra small phones - 360px and below */
          @media (max-width: 360px) {
            .menu-header {
              padding: 8px 10px;
            }

            .menu-title {
              font-size: 14px;
            }

            .menu-title svg {
              font-size: 15px;
            }

            .category-name {
              font-size: 12px;
            }

            .category-header svg {
              font-size: 14px;
            }

            .menu-item-name {
              font-size: 11px;
            }

            .quantity-controls {
              min-width: 100px;
            }

            .quantity-btn {
              width: 24px;
              height: 24px;
            }

            .quantity-display {
              font-size: 12px;
            }

            .cart-items-count {
              font-size: 14px;
            }

            .send-btn {
              padding: 7px 12px;
              font-size: 11px;
            }
          }
                `}

            </style>
            <form onSubmit={submitData} className="menu-container">
                {totalQuantity > 0 && (
                    <div className="cart-footer">
                        <div className="cart-content">
                            <div className="cart-info">
                                <div className="cart-icon-wrapper">
                                    <RestaurantMenu style={{ color: 'white' }} />
                                </div>
                                <div className="cart-details">
                                    <div className="cart-items-count">{totalQuantity}</div>
                                    <div className="cart-label">NEW ITEMS</div>
                                </div>
                            </div>

                            <Button
                                className="send-btn"
                                onClick={submitData}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <CircularProgress size={24} color="inherit" />
                                ) : (
                                    <>
                                        <SendIcon />
                                        Send to Kitchen
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                )}
                {/* Modern Action Bar */}
                {totalQuantity == 0 && (
                    <div className="kot-action-bar">
                        {/* Items Info Section */}
                        <div className="kot-items-info">
                            <div className="kot-payment-icon">
                                <Payment />
                            </div>
                            <div className="kot-items-text">
                                <div className="kot-items-count">{getTotalQuantity()}</div>
                                <div className="kot-items-label">Items Added</div>
                            </div>
                        </div>

                        {/* Actions Group */}
                        <div className="kot-actions-group">
                            {hasCreateTransactionPermission && roleName !== "Counter" && (
                                <Button
                                    className="kot-action-btn kot-btn-bill"
                                    onClick={openDetailModal}
                                >
                                    Bill
                                </Button>
                            )}

                            {hasEditTransactionPermission && roleName !== "Counter" && (
                                <Button
                                    className="kot-action-btn kot-btn-edit"
                                    onClick={openDetailModalEditKot}
                                >
                                    Edit Kot
                                </Button>
                            )}

                            {hasEditTransactionPermission && (
                                <Fragment>
                                    <Button
                                        className="kot-action-btn kot-btn-reprint"
                                        onClick={() => setIsPasswordDialogOpen(true)}
                                    >
                                        Reprint
                                    </Button>

                                    {isPasswordDialogOpen && (
                                        <div style={{
                                            position: "fixed",
                                            inset: 0,
                                            background: "rgba(0, 0, 0, 0.4)",
                                            backdropFilter: "blur(8px)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 1000,
                                            padding: "16px",
                                            animation: "fadeIn 0.3s ease-out"
                                        }}>
                                            <div style={{
                                                background: "linear-gradient(135deg, #fdfbf7 0%, #f8f6f2 50%, #f5f3ef 100%)",
                                                borderRadius: "20px",
                                                width: "100%",
                                                maxWidth: "420px",
                                                boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                                                border: "1px solid rgba(139, 92, 246, 0.15)",
                                                animation: "slideUp 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                                overflow: "hidden"
                                            }}>
                                                {/* Header */}
                                                <div style={{
                                                    background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                                                    padding: "20px 24px",
                                                    borderBottom: "1px solid rgba(139, 92, 246, 0.2)"
                                                }}>
                                                    <h2 style={{
                                                        margin: 0,
                                                        fontSize: "22px",
                                                        fontWeight: 700,
                                                        color: "white",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px"
                                                    }}>
                                                        <span style={{ fontSize: "26px" }}>🔐</span>
                                                        <span>Password Verification</span>
                                                    </h2>
                                                    <p style={{
                                                        margin: "6px 0 0 0",
                                                        fontSize: "13px",
                                                        color: "rgba(255, 255, 255, 0.9)",
                                                        fontWeight: 400
                                                    }}>
                                                        Enter password to reprint KOT
                                                    </p>
                                                </div>

                                                {/* Content */}
                                                <div style={{ padding: "24px" }}>
                                                    <div style={{ marginBottom: "20px" }}>
                                                        <label style={{
                                                            display: "block",
                                                            fontSize: "12px",
                                                            fontWeight: 700,
                                                            color: "#6d28d9",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            marginBottom: "8px"
                                                        }}>
                                                            Password <span style={{ color: "#ef4444" }}>*</span>
                                                        </label>
                                                        <input
                                                            type="password"
                                                            value={password}
                                                            onChange={handlePasswordChange}
                                                            placeholder="Enter your password"
                                                            style={{
                                                                width: "100%",
                                                                height: "44px",
                                                                padding: "10px 14px",
                                                                border: passwordError ? "2px solid #ef4444" : "2px solid #e9d5ff",
                                                                borderRadius: "10px",
                                                                fontSize: "14px",
                                                                color: "#1f2937",
                                                                background: "white",
                                                                transition: "all 0.2s ease",
                                                                outline: "none",
                                                                boxSizing: "border-box"
                                                            }}
                                                            onFocus={(e) => {
                                                                if (!passwordError) {
                                                                    e.target.style.borderColor = "#8b5cf6";
                                                                    e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.1)";
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                if (!passwordError) {
                                                                    e.target.style.borderColor = "#e9d5ff";
                                                                    e.target.style.boxShadow = "none";
                                                                }
                                                            }}
                                                            onKeyPress={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    handlePasswordCheck();
                                                                }
                                                            }}
                                                        />
                                                        {passwordError && (
                                                            <div style={{
                                                                marginTop: "8px",
                                                                fontSize: "12px",
                                                                color: "#ef4444",
                                                                fontWeight: 500,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "4px"
                                                            }}>
                                                                <span>⚠️</span>
                                                                <span>{passwordError}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Buttons */}
                                                    <div style={{
                                                        display: "flex",
                                                        gap: "12px",
                                                        marginTop: "24px"
                                                    }}>
                                                        <button
                                                            onClick={handlePasswordCheck}
                                                            style={{
                                                                flex: 1,
                                                                height: "44px",
                                                                background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                                                                color: "white",
                                                                border: "none",
                                                                borderRadius: "10px",
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                cursor: "pointer",
                                                                boxShadow: "0 4px 12px rgba(139, 92, 246, 0.3)",
                                                                transition: "all 0.3s ease",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                gap: "8px"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.transform = "translateY(-2px)";
                                                                e.target.style.boxShadow = "0 6px 16px rgba(139, 92, 246, 0.4)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.transform = "translateY(0)";
                                                                e.target.style.boxShadow = "0 4px 12px rgba(139, 92, 246, 0.3)";
                                                            }}
                                                        >
                                                            <span>✓</span>
                                                            <span>Confirm</span>
                                                        </button>
                                                        <button
                                                            onClick={() => {
                                                                setIsPasswordDialogOpen(false);
                                                                setPassword('');
                                                                setPasswordError('');
                                                            }}
                                                            style={{
                                                                flex: 1,
                                                                height: "44px",
                                                                background: "white",
                                                                color: "#6b7280",
                                                                border: "2px solid #e5e7eb",
                                                                borderRadius: "10px",
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                cursor: "pointer",
                                                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                                                                transition: "all 0.3s ease"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.background = "#f9fafb";
                                                                e.target.style.borderColor = "#d1d5db";
                                                                e.target.style.transform = "translateY(-2px)";
                                                                e.target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.background = "white";
                                                                e.target.style.borderColor = "#e5e7eb";
                                                                e.target.style.transform = "translateY(0)";
                                                                e.target.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.05)";
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Fragment>
                            )}

                            {hasDeleteTransactionPermission && (
                                <Button
                                    className="kot-action-btn kot-btn-cancel"
                                    onClick={CancelRecord}
                                >
                                    Cancel
                                </Button>
                            )}
                        </div>
                    </div>
                )}

                {/* Cancel Confirmation Modal */}
                {isCancelConfirmOpen && (
                    <div style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0, 0, 0, 0.5)",
                        backdropFilter: "blur(8px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                        padding: "16px",
                        animation: "fadeIn 0.3s ease-out"
                    }}>
                        <div style={{
                            background: "linear-gradient(135deg, #fdfbf7 0%, #f8f6f2 50%, #f5f3ef 100%)",
                            borderRadius: "20px",
                            width: "100%",
                            maxWidth: "480px",
                            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                            border: "1px solid rgba(239, 68, 68, 0.2)",
                            animation: "slideUp 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                            overflow: "hidden"
                        }}>
                            {/* Header */}
                            <div style={{
                                background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                                padding: "24px 28px",
                                borderBottom: "1px solid rgba(239, 68, 68, 0.2)"
                            }}>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    marginBottom: "8px"
                                }}>
                                    <div style={{
                                        width: "48px",
                                        height: "48px",
                                        background: "rgba(255, 255, 255, 0.2)",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "28px"
                                    }}>
                                        ⚠️
                                    </div>
                                    <h2 style={{
                                        margin: 0,
                                        fontSize: "24px",
                                        fontWeight: 700,
                                        color: "white"
                                    }}>
                                        Cancel KOT?
                                    </h2>
                                </div>
                            </div>

                            {/* Content */}
                            <div style={{ padding: "28px" }}>
                                <div style={{
                                    background: "#fef2f2",
                                    border: "2px solid #fecaca",
                                    borderRadius: "12px",
                                    padding: "16px",
                                    marginBottom: "24px"
                                }}>
                                    <p style={{
                                        margin: 0,
                                        fontSize: "15px",
                                        color: "#991b1b",
                                        lineHeight: "1.6",
                                        fontWeight: 500
                                    }}>
                                        Are you sure you want to cancel this KOT? This action cannot be undone and all items will be removed.
                                    </p>
                                </div>

                                <div style={{
                                    background: "white",
                                    border: "2px solid #e5e7eb",
                                    borderRadius: "12px",
                                    padding: "16px",
                                    marginBottom: "24px"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        marginBottom: "8px"
                                    }}>
                                        <TableRestaurantIcon style={{ color: "#6b7280", fontSize: "20px" }} />
                                        <span style={{
                                            fontSize: "14px",
                                            color: "#374151",
                                            fontWeight: 600
                                        }}>
                                            Table: {tableName}
                                        </span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px"
                                    }}>
                                        <AccessTimeIcon style={{ color: "#6b7280", fontSize: "20px" }} />
                                        <span style={{
                                            fontSize: "14px",
                                            color: "#6b7280"
                                        }}>
                                            {kotDate} • {kotTime}
                                        </span>
                                    </div>
                                </div>

                                {/* Buttons */}
                                <div style={{
                                    display: "flex",
                                    gap: "12px"
                                }}>
                                    <button
                                        onClick={() => setIsCancelConfirmOpen(false)}
                                        style={{
                                            flex: 1,
                                            height: "48px",
                                            background: "white",
                                            color: "#374151",
                                            border: "2px solid #e5e7eb",
                                            borderRadius: "12px",
                                            fontSize: "15px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                                            transition: "all 0.3s ease"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = "#f9fafb";
                                            e.target.style.borderColor = "#d1d5db";
                                            e.target.style.transform = "translateY(-2px)";
                                            e.target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = "white";
                                            e.target.style.borderColor = "#e5e7eb";
                                            e.target.style.transform = "translateY(0)";
                                            e.target.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.05)";
                                        }}
                                    >
                                        No, Keep It
                                    </button>
                                    <button
                                        onClick={handleCancelConfirm}
                                        disabled={isLoading}
                                        style={{
                                            flex: 1,
                                            height: "48px",
                                            background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "12px",
                                            fontSize: "15px",
                                            fontWeight: 600,
                                            cursor: isLoading ? "not-allowed" : "pointer",
                                            boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)",
                                            transition: "all 0.3s ease",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "8px",
                                            opacity: isLoading ? 0.6 : 1
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isLoading) {
                                                e.target.style.transform = "translateY(-2px)";
                                                e.target.style.boxShadow = "0 6px 16px rgba(239, 68, 68, 0.4)";
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = "translateY(0)";
                                            e.target.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.3)";
                                        }}
                                    >
                                        {isLoading ? (
                                            <CircularProgress size={20} color="inherit" />
                                        ) : (
                                            <>
                                                <span>✓</span>
                                                <span>Yes, Cancel KOT</span>
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {isModalOpen && (
                    <div className="invoice-modal-backdrop">
                        <div className="invoice-modal-container">
                            {/* Loading Overlay */}
                            {isLoading && (
                                <div className="invoice-loading-overlay">
                                    <div className="invoice-loading-content">
                                        <div className="invoice-loading-spinner"></div>
                                        <div className="invoice-loading-text">Processing Invoice...</div>
                                        <div className="invoice-loading-subtext">Please wait while we save your data</div>
                                    </div>
                                </div>
                            )}

                            <div className="invoice-modal-content">
                                {/* Header */}
                                <div className="invoice-modal-header">
                                    <h2 className="invoice-modal-title">
                                        <span className="invoice-modal-icon">🧾</span>
                                        Invoice
                                    </h2>

                                    {/* Info Card */}
                                    <div className="invoice-info-card">
                                        <div className="invoice-info-row">
                                            <div className="invoice-info-icon">
                                                <TableRestaurantIcon style={{ fontSize: '16px' }} />
                                            </div>
                                            <div className="invoice-info-text">
                                                <span className="invoice-info-label">Table:</span>
                                                <span className="invoice-info-value">{modalData.TableText}</span>
                                            </div>
                                        </div>
                                        <div className="invoice-info-row">
                                            <div className="invoice-info-icon">
                                                <AccessTimeIcon style={{ fontSize: '16px' }} />
                                            </div>
                                            <div className="invoice-info-time">
                                                {modalData.InvoiceDate} • {modalData.InvoiceTime}
                                            </div>
                                        </div>
                                    </div></div>
                            </div>

                            {/* Conditional Content - Show confirmation or normal invoice */}
                            {isSaveConfirmOpen ? (
                                /* Save Confirmation Content */
                                <div style={{ 
                                    padding: "16px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    maxWidth: "400px",
                                    margin: "0 auto"
                                }}>
                                    {/* Warning Banner */}
                                    <div style={{
                                        background: "#fffbeb",
                                        border: "2px solid #fcd34d",
                                        borderRadius: "8px",
                                        padding: "10px 14px",
                                        marginBottom: "12px",
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px"
                                    }}>
                                        <span style={{ fontSize: "20px" }}>⚠️</span>
                                        <span style={{ fontSize: "13px", color: "#92400e", fontWeight: 600 }}>
                                            Please verify the payment type before saving!
                                        </span>
                                    </div>

                                    {/* Payment Type Summary */}
                                    <div style={{
                                        background: "#f8fafc",
                                        border: "1.5px solid #e2e8f0",
                                        borderRadius: "8px",
                                        padding: "12px",
                                        marginBottom: "12px",
                                        width: "100%"
                                    }}>
                                        <div style={{ fontSize: "11px", color: "#64748b", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>
                                            Selected Payment Type
                                        </div>
                                        <div style={{ display: "flex", gap: "8px" }}>
                                            {[
                                                { label: "Cash", value: "1", emoji: "💵", color: "#16a34a", bg: "#f0fdf4", border: "#86efac" },
                                                { label: "Card", value: "2", emoji: "💳", color: "#1d4ed8", bg: "#eff6ff", border: "#93c5fd" },
                                                { label: "UPI",  value: "3", emoji: "📱", color: "#7c3aed", bg: "#f5f3ff", border: "#c4b5fd" },
                                            ].map((opt) => (
                                                <div key={opt.value} style={{
                                                    flex: 1,
                                                    padding: "8px 4px",
                                                    borderRadius: "8px",
                                                    border: `2px solid ${selectedPaymentType === opt.value ? opt.border : "#e2e8f0"}`,
                                                    background: selectedPaymentType === opt.value ? opt.bg : "#fff",
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s",
                                                    boxShadow: selectedPaymentType === opt.value ? `0 0 0 3px ${opt.border}55` : "none"
                                                }}
                                                onClick={() => {
                                                    setSelectedPaymentType(opt.value);
                                                    setModalData(prev => ({ ...prev, PaymentType: opt.value }));
                                                }}
                                                >
                                                    <div style={{ fontSize: "20px", marginBottom: "2px" }}>{opt.emoji}</div>
                                                    <div style={{
                                                        fontSize: "12px",
                                                        fontWeight: 700,
                                                        color: selectedPaymentType === opt.value ? opt.color : "#6b7280"
                                                    }}>
                                                        {opt.label}
                                                    </div>
                                                    {selectedPaymentType === opt.value && (
                                                        <div style={{ fontSize: "10px", color: opt.color, marginTop: "2px" }}>✓ Selected</div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Confirm Message */}
                                    <div style={{
                                        background: "#f0fdf4",
                                        border: "2px solid #bbf7d0",
                                        borderRadius: "8px",
                                        padding: "10px 12px",
                                        marginBottom: "14px",
                                        textAlign: "center",
                                        width: "100%"
                                    }}>
                                        <p style={{ margin: 0, fontSize: "13px", color: "#166534", fontWeight: 500, lineHeight: "1.4" }}>
                                            Save invoice with <strong>{selectedPaymentType === "1" ? "💵 Cash" : selectedPaymentType === "2" ? "💳 Card" : "📱 UPI"}</strong> payment? This cannot be undone.
                                        </p>
                                    </div>

                                    {/* Buttons */}
                                    <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                                        <button
                                            onClick={() => setIsSaveConfirmOpen(false)}
                                            style={{
                                                flex: 1,
                                                height: "38px",
                                                background: "white",
                                                color: "#374151",
                                                border: "2px solid #e5e7eb",
                                                borderRadius: "8px",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                cursor: "pointer",
                                            }}
                                        >
                                            ← Go Back
                                        </button>
                                        <button
                                            onClick={handleSaveConfirm}
                                            disabled={isLoading}
                                            style={{
                                                flex: 1,
                                                height: "38px",
                                                background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "8px",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                cursor: isLoading ? "not-allowed" : "pointer",
                                                boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "6px",
                                                opacity: isLoading ? 0.6 : 1
                                            }}
                                        >
                                            {isLoading ? (
                                                <CircularProgress size={20} color="inherit" />
                                            ) : (
                                                <>
                                                    <span>✓</span>
                                                    <span>OK, Save Invoice</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                /* Normal Invoice Content */
                                <>
                            {/* Payment Section */}
                            <div className="invoice-payment-section">
                                {/* Payment Type */}
                                <div className="invoice-payment-group">
                                    <label className="invoice-label">Payment Mode</label>
                                    <div className="invoice-payment-options">
                                        {[
                                            { label: "Cash", value: "1", emoji: "💵" },
                                            { label: "Card", value: "2", emoji: "💳" },
                                            { label: "UPI", value: "3", emoji: "📱" },
                                        ].map((opt) => (
                                            <div
                                                key={opt.value}
                                                className={`invoice-payment-option ${selectedPaymentType === opt.value ? 'selected' : ''}`}
                                                onClick={() => handleChange({ target: { name: 'PaymentType', value: opt.value } })}
                                            >
                                                <input
                                                    type="radio"
                                                    name="PaymentType"
                                                    value={opt.value}
                                                    checked={selectedPaymentType === opt.value}
                                                    onChange={handleChange}
                                                />
                                                <span className="invoice-payment-icon">{opt.emoji}</span>
                                                <span className="invoice-payment-label">{opt.label}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div>
                                    <Button
                                        variant="contained"
                                        className="invoice-add-item-btn"
                                        onClick={toggleModalNewItem}
                                    >
                                        + ADD Item
                                    </Button>
                                </div>
                            </div>

                            {isModalOpenNewItem && (
                                <div className="add-item-modal-backdrop">
                                    <div className="add-item-modal-container">
                                        <div className="add-item-modal-content">
                                            <h2 className="add-item-modal-title">Add Item</h2>

                                            <div className="add-item-form-group">
                                                <label className="add-item-label">
                                                    Item Name
                                                    <span className="add-item-label-required">*</span>
                                                </label>
                                                <Select
                                                    options={itemOptions}
                                                    value={selectedItem}
                                                    onChange={handleItemSelect}
                                                    placeholder="Select Item"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '38px',
                                                            borderColor: '#d1d5db',
                                                            borderWidth: '1.5px',
                                                            borderRadius: '8px',
                                                            '&:hover': {
                                                                borderColor: '#9ca3af'
                                                            }
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="add-item-form-group">
                                                <label className="add-item-label">Quantity</label>
                                                <input
                                                    className="add-item-input"
                                                    type="text"
                                                    name="Quantity"
                                                    placeholder="Enter Quantity"
                                                    value={newRecordData.Quantity}
                                                    onChange={handleInputChange}
                                                    style={{ textAlign: 'right' }}
                                                />
                                            </div>

                                            <div className="add-item-buttons">
                                                <button
                                                    className="add-item-btn add-item-btn-update"
                                                    onClick={addRecord}
                                                >
                                                    Update
                                                </button>
                                                <button
                                                    className="add-item-btn add-item-btn-cancel"
                                                    onClick={toggleModalNewItem}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                            {/* Input Grid */}
                            <div className="invoice-input-grid">
                                {/* Invoice No */}
                                <div className="invoice-input-group">
                                    <label className="invoice-label">Invoice No</label>
                                    <input
                                        className="invoice-input"
                                        type="text"
                                        name="InvoiceNumber"
                                        value={modalData.InvoiceNumber}
                                        style={{ textAlign: 'right' }}
                                        readOnly
                                    />
                                </div>

                                {/* Discount */}
                                <div className="invoice-input-group">
                                    <label className="invoice-label">Discount %</label>
                                    {(companyId === "4" || companyId === "1") ? (
                                        <select
                                            className="invoice-select"
                                            name="DiscountPer"
                                            value={selecteDiscount}
                                            onChange={handleChange}
                                            style={{ textAlign: 'right' }}
                                        >
                                            <option value="">Disc %</option>
                                            {discountOptions.map((option) => (
                                                <option key={option.DiscPercentage} value={option.DiscPercentage}>
                                                    {option.DiscPercentage}%
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            className="invoice-input"
                                            type="text"
                                            name="DiscountPer"
                                            value={modalData.DiscountPer}
                                            onChange={handleChange}
                                            style={{ textAlign: 'right' }}
                                        />
                                    )}
                                </div>

                                {/* Total Amount */}
                                <div className="invoice-input-group">
                                    <label className="invoice-label">Total Amount</label>
                                    <input
                                        className="invoice-input"
                                        type="text"
                                        name="TotalAmount"
                                        value={modalData.TotalAmount}
                                        style={{ textAlign: 'right' }}
                                        readOnly
                                    />
                                </div>
                            </div>

                            {/* Items Table */}
                            <div className="invoice-table-container">
                                <TableContainer component={Paper} sx={{ maxHeight: 250, overflowX: "auto" }}>
                                    <Table stickyHeader size="small" sx={{ minWidth: 520 }}>
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: "#f9fafb" }}>
                                                <TableCell sx={{ fontWeight: "bold", color: "#374151", fontSize: "12.5px", width: 130, minWidth: 130 }}>
                                                    Item
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: "bold", color: "#374151", fontSize: "12.5px", width: 60, minWidth: 60 }}>
                                                    Qty
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: "bold", color: "#374151", fontSize: "12.5px", width: 60, minWidth: 60 }}>
                                                    Rate
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: "bold", color: "#374151", fontSize: "12.5px", width: 70, minWidth: 70 }}>
                                                    Amount
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "bold", color: "#374151", fontSize: "12.5px", width: 120, minWidth: 120 }}>
                                                    Remark
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: "bold", color: "#374151", fontSize: "12.5px", width: 40, minWidth: 40 }}>

                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemdata.map((item, index) => (
                                                <TableRow
                                                    key={item.Id}
                                                    sx={{
                                                        backgroundColor: item.IsActive === false ? "#f27c8dff" : "inherit",
                                                    }}
                                                >
                                                    <TableCell sx={{ py: 0.4, fontSize: "12.5px", whiteSpace: "normal", wordBreak: "break-word", width: 130, minWidth: 130 }}>
                                                        {item.ItemName}
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 0.4, fontSize: "12.5px", width: 60, minWidth: 60 }}>
                                                        <input
                                                            type="number"
                                                            value={item.Quantity}
                                                            onChange={(e) => handleCalculation(e, index)}
                                                            className="invoice-table-input invoice-table-input-number"
                                                            name="Quantity"
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 0.4, fontSize: "12.5px", width: 60, minWidth: 60 }}>
                                                        {item.Rate}
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 0.4, fontSize: "12.5px", width: 70, minWidth: 70 }}>
                                                        {item.Amount}
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ py: 0.4, fontSize: "12.5px", width: 120, minWidth: 120 }}>
                                                        <input
                                                            type="text"
                                                            value={item.description}
                                                            onChange={(e) => handleCalculation(e, index)}
                                                            className="invoice-table-input"
                                                            name="description"
                                                            placeholder="Add remark..."
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ fontSize: "12.5px", width: 40, minWidth: 40 }}>
                                                        {item.IsActive && (
                                                            <IconButton
                                                                style={{ padding: "4px", marginTop: "-5px" }}
                                                                onClick={() => removeRecord(index)}
                                                            >
                                                                <DeleteIcon style={{ color: "#d21f19ff", fontSize: "14px" }} />
                                                            </IconButton>
                                                        )}
                                                    </TableCell>

                                                </TableRow>

                                            ))}
                                            {/* ✅ TOTAL ROW (only active items) */}
                                            <TableRow
                                                sx={{
                                                    backgroundColor: "#f5f5f5",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <TableCell
                                                    sx={{ py: 0.5, fontSize: "13px", fontWeight: 600 }}
                                                >
                                                    Total (Active)
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    sx={{ py: 1, fontSize: "13px", fontWeight: 600 }}
                                                >
                                                    {itemdata
                                                        .filter((item) => item.IsActive)
                                                        .reduce((total, item) => total + (Number(item.Quantity) || 0), 0)}
                                                </TableCell>
                                                <TableCell align="center" sx={{ py: 0.5 }}></TableCell>
                                                <TableCell
                                                    align="center"
                                                    sx={{ py: 0.5, fontSize: "13px", fontWeight: 600 }}
                                                >
                                                    {itemdata
                                                        .filter((item) => item.IsActive)
                                                        .reduce((total, item) => total + (Number(item.Amount) || 0), 0)
                                                        .toFixed(2)}
                                                </TableCell>
                                                <TableCell sx={{ py: 0.5 }}></TableCell>
                                                <TableCell sx={{ py: 0.5 }}></TableCell>
                                            </TableRow>
                                        </TableBody>

                                    </Table>
                                </TableContainer>
                            </div>

                            {/* Footer Buttons - Only show when not in confirmation mode */}
                            {!isSaveConfirmOpen && (
                                <div className="invoice-footer">
                                    <button
                                        className="invoice-btn invoice-btn-save"
                                        onClick={updateRecord}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? <CircularProgress size={18} color="inherit" /> : (
                                            <>
                                                <span>💾</span>
                                                <span>Save Invoice</span>
                                            </>
                                        )}
                                    </button>
                                    <button
                                        className="invoice-btn invoice-btn-cancel"
                                        onClick={toggleModal}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            )}
                            </>
                            )}
                        </div>
                    </div>

                )
                }


                {
                    isModalDiscOpen && (
                        <DescriptionModal
                            isOpen={isModalDiscOpen}
                            onClose={() => setIsModalDiscOpen(false)}
                            itemId={selectedItemId}
                            description={description}
                            onSave={saveDescription}
                        />
                    )
                }





                {
                    isModalEditOpen && (
                        <Modal open={isModalEditOpen} className={isModalEditOpen ? 'notification-modal' : ''}>
                            <div className="fixed inset-0 flex items-start justify-center z-10 ">
                                <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '70%', maxHeight: '50vh', overflowY: 'auto', overflowX: 'auto', marginTop: '50px' }}>

                                    <h5 style={{ textAlign: 'center' }}>Table Change</h5>
                                    <div className="w-full">
                                        <label
                                            style={{
                                                display: "block",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.05em",
                                                color: "black",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                marginBottom: "8px",
                                            }}
                                            htmlFor="gstNumber"
                                        >
                                            Name
                                            <span style={{ color: "red" }}>*</span>
                                        </label>

                                        <select
                                            style={{
                                                width: "100%",
                                                height: "35px",
                                                padding: "5px",
                                                borderRadius: "4px",
                                                border: "1px solid #ccc",
                                                fontSize: "14px",
                                            }}
                                            value={selectedTable}
                                            onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                setSelectedTable(selectedValue);

                                                // Find the selected table's record in dropdownTableOptions
                                                const selectedTableRecord = dropdownTableOptions.find(
                                                    (category) => category.Id === selectedValue
                                                );

                                                // Update formData with TableId and GstNotApplicable
                                                setModalData((prevData) => ({
                                                    ...prevData,
                                                    TableId: selectedValue,

                                                }));
                                                setTableId(selectedValue)
                                            }}
                                        >
                                            <option value="">Table</option>
                                            {dropdownTableOptions.map((category) => (
                                                <option key={category.Id} value={category.Id}>
                                                    {category.Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <br></br>
                                    <div className="w-1/2 flex justify-end">
                                        <Button className="bg-green-500 text-white px-2 py-1 rounded"
                                            style={{
                                                backgroundColor: '#AEEA94',
                                                borderRadius: '50px',
                                                padding: '10px 20px',
                                                color: 'whitesmoke',
                                                fontWeight: 'bolder',
                                                textTransform: 'none',
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                                maxHeight: '35px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginLeft: '10px',

                                            }} disabled={isLoading} onClick={handleUpdate}
                                        >
                                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Update</b>}
                                        </Button>
                                        <Button className="bg-blue-500 text-white px-2 py-1 rounded ml-2"
                                            style={{
                                                backgroundColor: '#D2665A',
                                                borderRadius: '50px',
                                                padding: '10px 20px',
                                                color: 'whitesmoke',
                                                fontWeight: 'bolder',
                                                textTransform: 'none',
                                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                                maxHeight: '35px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginLeft: '10px',

                                            }}
                                            onClick={closeEditModal}>
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </div>

                        </Modal >
                    )
                }

                {
                    isModalOpenEditKot && (

                        <div className="edit-kot-modal-backdrop">
                            <div className="edit-kot-modal-container">
                                {/* Loading Overlay */}
                                {isLoading && (
                                    <div className="edit-kot-loading-overlay">
                                        <div className="edit-kot-loading-spinner"></div>
                                        <div className="edit-kot-loading-text">Updating KOT...</div>
                                        <div className="edit-kot-loading-subtext">Please wait while we save your changes</div>
                                    </div>
                                )}

                                <div className="invoice-modal-content">
                                    {/* Header */}
                                    <div className="invoice-modal-header">
                                        <h2 className="invoice-modal-title">
                                            <span className="invoice-modal-icon">🧾</span>
                                            Edit KOT
                                        </h2>
                                        {/* Info Card */}
                                        <div className="invoice-info-card">
                                            <div className="invoice-info-row">
                                                <div className="invoice-info-icon">
                                                    <TableRestaurantIcon style={{ fontSize: '16px' }} />
                                                </div>
                                                <div className="invoice-info-text">
                                                    <span className="invoice-info-label">Table:</span>
                                                    <span className="invoice-info-value">{modalDataEditKot.TableText}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Items Table */}
                                    <div className="invoice-table-container">
                                        <TableContainer component={Paper} sx={{ maxHeight: 280, overflowX: "auto" }}>
                                            <Table stickyHeader size="small" sx={{ minWidth: 380 }}>
                                                <TableHead>
                                                    <TableRow sx={{ 
                                                        background: "linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)"
                                                    }}>
                                                        <TableCell sx={{ 
                                                            fontWeight: 700, 
                                                            color: "#6d28d9", 
                                                            fontSize: "13px",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            width: 140, minWidth: 140
                                                        }}>
                                                            Item
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ 
                                                            fontWeight: 700, 
                                                            color: "#6d28d9", 
                                                            fontSize: "13px",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            width: 80, minWidth: 80
                                                        }}>
                                                            Qty
                                                        </TableCell>
                                                        <TableCell sx={{ 
                                                            fontWeight: 700, 
                                                            color: "#6d28d9", 
                                                            fontSize: "13px",
                                                            textTransform: "uppercase",
                                                            letterSpacing: "0.5px",
                                                            width: 160, minWidth: 160
                                                        }}>
                                                            Remark
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {itemdataEditKot.map((item, index) => (
                                                        <TableRow
                                                            key={item.Id}
                                                            sx={{
                                                                backgroundColor: item.IsActive === false ? "#fee2e2" : "white",
                                                                transition: "all 0.2s ease",
                                                                "&:hover": {
                                                                    backgroundColor: item.IsActive === false ? "#fecaca" : "#faf5ff"
                                                                }
                                                            }}
                                                        >
                                                            <TableCell sx={{ 
                                                                py: 0.8, 
                                                                fontSize: "13px",
                                                                color: "#374151",
                                                                fontWeight: 500,
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-word",
                                                                width: 140, minWidth: 140
                                                            }}>
                                                                {item.ItemName}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ py: 0.8, fontSize: "13px", width: 80, minWidth: 80 }}>
                                                                <input
                                                                    type="number"
                                                                    value={item.Quantity}
                                                                    onChange={(e) => handleCalculationEdit(e, index)}
                                                                    style={{
                                                                        width: "80px",
                                                                        height: "36px",
                                                                        padding: "6px 10px",
                                                                        border: "1.5px solid #e9d5ff",
                                                                        borderRadius: "8px",
                                                                        fontSize: "13px",
                                                                        color: "#1f2937",
                                                                        background: "white",
                                                                        textAlign: "right",
                                                                        fontWeight: 600,
                                                                        transition: "all 0.2s ease"
                                                                    }}
                                                                    onFocus={(e) => {
                                                                        e.target.style.borderColor = "#8b5cf6";
                                                                        e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.1)";
                                                                        e.target.style.background = "#fdfbf7";
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        e.target.style.borderColor = "#e9d5ff";
                                                                        e.target.style.boxShadow = "none";
                                                                        e.target.style.background = "white";
                                                                    }}
                                                                    name="Quantity"
                                                                />
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ py: 0.8, fontSize: "13px", width: 160, minWidth: 160 }}>
                                                                <input
                                                                    type="text"
                                                                    value={item.description}
                                                                    onChange={(e) => handleCalculationEdit(e, index)}
                                                                    style={{
                                                                        width: "100%",
                                                                        maxWidth: "320px",
                                                                        height: "36px",
                                                                        padding: "6px 12px",
                                                                        border: "1.5px solid #e9d5ff",
                                                                        borderRadius: "8px",
                                                                        fontSize: "13px",
                                                                        color: "#1f2937",
                                                                        background: "white",
                                                                        transition: "all 0.2s ease"
                                                                    }}
                                                                    onFocus={(e) => {
                                                                        e.target.style.borderColor = "#8b5cf6";
                                                                        e.target.style.boxShadow = "0 0 0 3px rgba(139, 92, 246, 0.1)";
                                                                        e.target.style.background = "#fdfbf7";
                                                                    }}
                                                                    onBlur={(e) => {
                                                                        e.target.style.borderColor = "#e9d5ff";
                                                                        e.target.style.boxShadow = "none";
                                                                        e.target.style.background = "white";
                                                                    }}
                                                                    name="description"
                                                                    placeholder="Add remark..."
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>

                                    {/* Footer Buttons */}
                                    <div className="invoice-footer">
                                        <button
                                            className="invoice-btn invoice-btn-save"
                                            onClick={updateRecordEditKot}
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <CircularProgress size={16} color="inherit" />
                                            ) : (
                                                <><span>💾</span><span>Save Changes</span></>
                                            )}
                                        </button>
                                        <button
                                            className="invoice-btn invoice-btn-cancel"
                                            onClick={toggleModalEditKot}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }


                <div className="menu-header">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'nowrap' }}>
                        <h1 className="menu-title" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', flexShrink: 0 }}>
                            <ModeEditOutlineIcon
                                onClick={openEditModal}
                                style={{
                                    color: '#fc4a1a',
                                    cursor: 'pointer',
                                    fontSize: 20
                                }}
                            />
                            <RestaurantIcon />
                            {tableName}
                        </h1>
                        <IconButton
                            size="small"
                            onClick={() => setShowContact((v) => !v)}
                            title="Contact Details"
                            style={{
                                flexShrink: 0,
                                background: showContact ? 'rgba(106,130,59,0.15)' : 'transparent',
                                border: '1px solid rgba(106,130,59,0.3)',
                                borderRadius: '6px',
                                padding: '3px',
                                color: '#6a823b',
                            }}
                        >
                            <PhoneIcon style={{ fontSize: 15 }} />
                        </IconButton>
                        {showContact && (
                            <input
                                autoFocus
                                type="text"
                                placeholder="Contact (Phone / Name)"
                                value={contactDetails}
                                onChange={(e) => setContactDetails(e.target.value)}
                                style={{
                                    flex: 1,
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    border: '1px solid rgba(106,130,59,0.3)',
                                    fontSize: '11px',
                                    background: '#fff',
                                    color: '#2e3a1f',
                                    outline: 'none',
                                    minWidth: 0,
                                }}
                            />
                        )}
                        <div className="menu-subtitle" style={{ fontWeight: 700, fontSize: '11px', whiteSpace: 'nowrap', flexShrink: 0 }}>
                            {kotDate} • {kotTime}
                        </div>
                    </div>
                </div>
                {
                    categoryData.map((category) => (
                        <div key={category.CategoryName} className="category-card">
                            <div
                                className="category-header"
                                onClick={() => handleExpandClick(category.CategoryName)}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1 }}>
                                    <LocalDiningIcon style={{ color: '#56ab2f' }} />
                                    <span className="category-name">{category.CategoryName}</span>
                                </div>

                                {getTotalQuantityForCategory(category.CategoryId) > 0 && (
                                    <Badge
                                        badgeContent={getTotalQuantityForCategory(category.CategoryId)}
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                background: 'linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)',
                                                color: 'white',
                                                fontWeight: 700,
                                                fontSize: '13px',
                                                padding: '0 8px',
                                                height: '24px',
                                                minWidth: '24px',
                                                borderRadius: '12px'
                                            }
                                        }}
                                    >
                                        <ShoppingCartIcon style={{ color: '#f7b733' }} />
                                    </Badge>
                                )}

                                <ExpandMoreIcon
                                    className={`expand-icon ${expandedCategories.includes(category.CategoryName) ? 'expanded' : ''}`}
                                />
                            </div>

                            <Collapse in={expandedCategories.includes(category.CategoryName)} timeout="auto" unmountOnExit>
                                <div>
                                    {category.Items.map((item) => {
                                        const quantity = selectedItems.find((selectedItem) => selectedItem.ItemId === item.Id)?.Quantity || 0;
                                        const orderedQty = getOrderTotalQuantity(item.Id);
                                        return (
                                            <div key={item.Id} className="menu-item-row" style={{
                                                background: orderedQty > 0 ? '#e8f5e9' : 'transparent'
                                            }}>
                                                <div className="menu-item-name">
                                                    {orderedQty > 0 && (
                                                        <span style={{
                                                            color: '#56ab2f',
                                                            fontWeight: 700,
                                                            marginRight: '6px'
                                                        }}>
                                                            ({orderedQty})
                                                        </span>
                                                    )}
                                                    {item.Name}
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div className="quantity-controls">
                                                        {quantity > 0 && (
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedItemId(item.Id);
                                                                    setDescription(selectedItems.find((selectedItem) => selectedItem.ItemId === item.Id)?.description || '');
                                                                    setIsModalDiscOpen(true);
                                                                }}
                                                                style={{ padding: 0 }}
                                                            >
                                                                <div className="info-btn">
                                                                    <InfoIcon style={{ fontSize: 16 }} />
                                                                </div>
                                                            </IconButton>
                                                        )}

                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleDecrement(item.Id)}
                                                            style={{ padding: 0, marginLeft: '10px' }}
                                                        >
                                                            <div className="quantity-btn remove">
                                                                <RemoveIcon style={{ fontSize: 16 }} />
                                                            </div>
                                                        </IconButton>

                                                        <span className="quantity-display">{quantity}</span>

                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleIncrement(item.CategoryId, item.Id, item.Name)}
                                                            style={{ padding: 0 }}
                                                        >
                                                            <div className="quantity-btn">
                                                                <AddIcon style={{ fontSize: 16 }} />
                                                            </div>
                                                        </IconButton>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Collapse>
                        </div>
                    ))
                }
                <div className="flex mb-2">
                    <div>
                        <p className="text-white font-bold" hidden>{kotTime}</p>
                    </div>
                </div>
                <div className="flex mb-2">
                    <div>
                        <p className="text-white font-bold" hidden>{kotDate}</p>
                    </div>
                </div>
            </form >

            {/* Advanced ProMax Loading for Bill Save */}
            <BillSaveLoader 
                isVisible={isBillSaving}
                title="Saving Bill"
                subtitle="Processing your transaction and generating receipt..."
                progress={true}
            />

            {/* Advanced ProMax Loading for KOT Save */}
            <BillSaveLoader 
                isVisible={isKotSaving}
                title="Updating KOT"
                subtitle="Saving your changes and updating the kitchen order..."
                progress={true}
            />
        </div >
    );
};

export default EditKOT;
